<template>
  <v-pagination
    total-visible="6"
    prev-icon="$vuetify.icons.arrowLeft"
    next-icon="$vuetify.icons.arrowRight"
    :value="value"
    @input="changePage($event)"
    :length="totalPageCount"
  />
</template>
<script>
import goTo from 'vuetify/es5/services/goto'
export default {
  name: 'Pagination',
  props: {
    value: {
      required: true,
      default: () => 0
    },
    totalPageCount: {
      required: true,
      default: () => 0
    },
    selector: {
      required: false
    }
  },
  methods: {
    changePage(pageIndex) {
      this.$emit('input', pageIndex)
      if (this.selector) {
        goTo(this.selector, { duration: 500, offset: 100 })
      } else {
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>
<style lang="scss">
.v-pagination {
  .v-pagination__item,
  .v-pagination__navigation,
  .v-pagination__item--active {
    background-color: transparent !important;
  }
  .v-pagination__item--active {
    color: #549ec7;
    border: 1px solid #549ec7;
  }

  .v-pagination__item,
  .v-pagination__navigation {
    box-shadow: none;
    border-radius: 0;
    font-size: 1.6rem;
  }
}
</style>
